// Reference markup: .game-header > span.game-header-name + span.float-right.game-header-date (styled by index.css)
export default function CasinoHeading({ name, roundId, onRulesClick }) {
  return (
    <div className="game-header">
      <span className="game-header-name">
        {name}
        {onRulesClick && (
          <span className="small-text" onClick={onRulesClick} style={{ cursor: "pointer", textDecoration: "underline" }}>
            {" "}Rules
          </span>
        )}
      </span>{" "}
      <span className="float-right game-header-date">Round ID: {roundId}</span>
    </div>
  );
}
